import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateFormatPipe',
})
export class dateFormatPipe implements PipeTransform {
    transform(value: string) {
       var datePipe = new DatePipe("en-US");
        value = datePipe.transform(value, 'MM/dd/yyyy HH:MM:ss');
        return value;
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/_pipes/datePipe.pipe.ts